import React from 'react';
import { ABAC } from '../../../../../primary-record-types';
import { getIntl } from '../../../../../utils/intl';
import Stack, { contentStackSpacing } from '../../../../v2BaseComponents/Stack';
import { noAccessAppPermissions } from '../../../../../utils/defaultPermissions';
import PermissionsInput from '../../../PermissionsInput';
import Text from '../../../../v2BaseComponents/Text';
import Button from '../../../../v2BaseComponents/Button';
import StepCompleteButton from '../StepCompleteButton';
import StepPaper from '../StepPaper';
import MainContentContainer, { mainContentPadding } from '../../../../v2BaseComponents/MainContentContainer';

const intl = getIntl('organization-client-invite-permission-step', {
    existingPermissionsHeader:
        "The organization has requested the following permissions for accessing the client's profile.  It is ultimately your choice what permissions you grant the organization for the client's profile.",
    noPermissionsHeader:
        'Please select the permissions you would like to grant the organization for the client profile.',
    organizationPermissions: 'Organization Permissions',
    reset: 'Reset',
    submit: 'Submit',
    reviewPermissions: 'Review Permissions',
});

export type PermissionsStepOwnProps = {
    defaultPermissions: ABAC.AppPermissions | null;
    onSubmit: (permissions: ABAC.AppPermissions) => void;
};

export type PermissionsStepProps = PermissionsStepOwnProps;

const PermissionsStep: React.FC<PermissionsStepProps> = (props) => {
    const defaultPermissions = props.defaultPermissions || noAccessAppPermissions;
    const [permissionValue, setPermissionValue] = React.useState<ABAC.AppPermissions>(defaultPermissions);
    return (
        <StepPaper stepIndex={1} stepTitle={intl('reviewPermissions')}>
            <Stack vertical fullWidth align="center" space={contentStackSpacing}>
                <MainContentContainer>
                    <Text variant="body-1"> {intl('existingPermissionsHeader')}</Text>
                </MainContentContainer>
                <Stack vertical align="center" fullWidth>
                    <PermissionsInput
                        value={permissionValue}
                        onChange={setPermissionValue}
                        showEditCollaboratorWarning
                        initialAppPermissions={defaultPermissions}
                    />
                    {props.defaultPermissions ? (
                        <Stack fullWidth horizontal justify="flex-end">
                            <Button
                                variant="ghost"
                                title={intl('reset')}
                                onPress={() => setPermissionValue(defaultPermissions)}
                                icon="RefreshCcw"
                            />
                        </Stack>
                    ) : null}
                </Stack>
                <Stack vertical fullWidth align="center" style={{ paddingBottom: mainContentPadding }}>
                    <StepCompleteButton
                        onPress={() => props.onSubmit(permissionValue)}
                        variant="next"
                        testID="organization-invitation-select-permissions-next-button"
                    />
                </Stack>
            </Stack>
        </StepPaper>
    );
};

export default React.memo(PermissionsStep);
